module.exports = __webpack_public_path__ + "media/web_bg.889e1ca3.mp4";